import React from 'react';
import './FooterLogos.scss';

import {
  FooterLogo1,
  FooterLogo2,
  FooterLogo3,
  FooterLogo4,
  FooterLogo5,
  FooterLogo6,
  FooterLogo7,
  FooterLogo8,
  FooterLogo9,
} from '../../../assets/img/svgs';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const logos = [
  <FooterLogo1 />,
  <FooterLogo2 />,
  <FooterLogo3 />,
  <FooterLogo4 />,
  <FooterLogo5 />,
  <FooterLogo6 />,
  <FooterLogo7 />,
  <FooterLogo8 />,
  <FooterLogo9 />,
  <FooterLogo1 />,
  <FooterLogo2 />,
  <FooterLogo3 />,
  <FooterLogo4 />,
  <FooterLogo5 />,
];

export default function FooterLogos() {
  return (
    <section id='logo-banner'>
      <div className='logos-swiper'>
        <Swiper
          spaceBetween={30}
          slidesPerView={2}
          loop={true}
          breakpoints={{
            // // when window width is >= 600px
            600: {
              slidesPerView: 4,
              spaceBetween: 60,
            },
            // when window width is >= 1200px
            1200: {
              slidesPerView: 6,
              spaceBetween: 60,
            },
          }}
        >
          {logos.map((logo) => (
            <SwiperSlide>{logo}</SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
